$(function(){

  /* ヘッダー固定 */
  var scroll;
  var objTop = $('.js-header-top').offset().top;
  fixed_header();
  $(window).on('scroll', function(){
    fixed_header();
  });
  function fixed_header(){
    scroll = $(window).scrollTop();
    objTop = $('.js-header-top').offset().top;
    if(scroll >= objTop){
      $('.js-header').addClass('is-fixed');
    }else{
      $('.js-header').removeClass('is-fixed');
    }
  }
  
/* ===== メニュードロワー 開閉の統合制御 ===== */
function isMenuOpen() {
  return $('.js-menudrawer').hasClass('is-open');
}
function openMenu() {
  $('.js-menudrawer').addClass('is-open');
  $('html,body').addClass('is-menudrawer-open');
  $('.js-header').addClass('is-menudrawer-open');
  $('.js-btmmenu-search').addClass('is-open');
  $('.js-btmmenu-search ._label').html('閉じる');
  $(window).trigger('menudrawer:opened');
}
function closeMenu() {
  $('.js-menudrawer').removeClass('is-open');
  $('html,body').removeClass('is-menudrawer-open');
  $('.js-header').removeClass('is-menudrawer-open');
  $('.js-btmmenu-search').removeClass('is-open');
  $('.js-btmmenu-search ._label').html('探す');
  $(window).trigger('menudrawer:closed'); // 他JSと連携用
}

/* SP:下部固定メニュー 探す（クリック） */
$('.js-btmmenu-search').on('click', function(){
  if (isMenuOpen()) {
    closeMenu();
  } else {
    openMenu();
  }
});

/* メニュー内：同一ページ内アンカークリックで自動クローズ */
$('.js-menudrawer').on('click', 'a[href]', function(){
  var href = $(this).attr('href') || '';
  if (!href.includes('#')) return;

  var samePageHash = false;
  try {
    var u = new URL(href, location.href);
    samePageHash = (u.pathname === location.pathname) && u.hash && (u.hash !== '#');
  } catch (e) {
    // 相対 "#id" 形式
    samePageHash = href.charAt(0) === '#' && href.length > 1;
  }
  if (samePageHash) {
    setTimeout(closeMenu, 0);
  }
});
  
  /* SP: 検索 */
  $('.js-search-clear').click(function(){
    $('.js-search-input').val('');
    $('.js-search-clear').fadeOut(300);
  });
  $('.js-search-input').on('keyup', function() {
    showClearBtn($(this));
  });
  $('.js-search-input').on('change', function() {
    showClearBtn($(this));
  });
  function showClearBtn($this){
    val = $this.val();
    if(val != ''){
      $this.next('.js-search-clear').fadeIn(300);
    }else{
      $this.next('.js-search-clear').fadeOut(300);
    }
  }
  
  /* SP: menu */
  $('.js-menudrawer-linklist-toggle').click(function(e){
    e.preventDefault();
    $(this).parent('a').next('.js-menudrawer-linklist-child').slideToggle();
  });
  
  /* チャット */
  $('.js-pscb-open').click(function(){
    $('#pscb_draggable_body').css('display', 'block');
  });
  
  /* カートアイコン ID付与 */
  if($(window).width() >= 1068){//pc
    $('.custom-header--desktop .js-carticon-count').attr('id', 'cart-drawer-toggle');
  }else{
    $('.custom-header--mobile .js-carticon-count').attr('id', 'cart-drawer-toggle');
  }

  /* カート追加後にカートページへ移動 (カートアイコンの更新を検知) */
  targets = document.querySelectorAll('.js-carticon-count');
  observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      if (window.location.pathname !== '/cart') {
        location.href = '/cart';
      }
    });
  });
  targets.forEach(target => {
    observer.observe(target, {
      childList: true,
      characterData: true,
      subtree: true
    });
  });

  /* 商品:スライダー */
  const sliderThumb = new Swiper('#js-swiper-thumb', {
    loop: false,
    slidesPerView: 5.6,
    spaceBetween: 3,
    centeredSlides: false,
    slideToClickedSlide: false,
    breakpoints: {
      1068: {
        slidesPerView: 10,
      }
    }
  });
  const sliderMain = new Swiper('#js-swiper-main', {
    loop: true,
    autoHeight: true,
    centeredSlides: true,
    slidesPerView: 1.01,
    spaceBetween: 3,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    pagination: {
      el: ".swiper-pagination",
      type: "fraction",
    },
    thumbs: {
      swiper: sliderThumb,
    },
    breakpoints: {
      1068: {
        slidesPerView: 1,
      }
    }
  });
  
});